

import { Component, OnInit, ViewChild } from "@angular/core"; //MOD INE(JJGJ) 20221018 - REQ22978 - SE AGREGO ViewChild
import { ConfiguracionesService } from "../service/configuraciones.service"; //ADD INE(JJGJ) 20221018 - REQ22978
import { HeaderComponent } from './header/header.component'; //ADD INE(JJGJ) 20221018 - REQ22978
import { MenuComponent } from './menu/menu.component';  //ADD INE(JJGJ) 20221018 - REQ22978
import { FooterComponent } from './footer/footer.component';//ADD INE(JJGJ) 20221018 - REQ22978
import { AuditoriaNavegacionClass } from "../funciones/auditoria"; //ADD INE(JJGJ) 20221018 - REQ22978
import { AuditoriaService } from "../../seguridad/services/auditoria.service"; //ADD INE(JJGJ) 20221018 - REQ22978

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  providers: [ConfiguracionesService,AuditoriaService], //ADD INE(JJGJ) 20221018 - REQ22978
})
export class LayoutComponent implements OnInit {
  public configuraciones: Array<ConfiguracionModel>; //ADD INE(JJGJ) 20221018 - REQ22978
  public showPrestamo: boolean = true; //ADD INE(JJGJ) 20221018 - REQ22978
  @ViewChild(HeaderComponent) header: HeaderComponent; //ADD INE(JJGJ) 20221018 - REQ22978
  @ViewChild(MenuComponent) menu: MenuComponent; //ADD INE(JJGJ) 20221018 - REQ22978
  @ViewChild(FooterComponent) footer: FooterComponent; //ADD INE(JJGJ) 20221018 - REQ22978
  private modulo = 'inicio'//ADD INE(JJGJ) 20221018 - REQ22978
  private opcion = '';//ADD INE(JJGJ) 20221018 - REQ22978
  public model: any = [];; //ADD INE(JJGJ) 20221018 - REQ22978
  constructor(
    private configuracionesService: ConfiguracionesService //ADD INE(JJGJ) 20221018 - REQ22978
    ,private auditoriaService: AuditoriaService //ADD INE(JJGJ) 20221018 - REQ22978
  ) {}

  ngOnInit() {
    //INI INE(JJGJ) 20221018 - REQ22978
    this.OnLoadConfiguraciones();
    const me = this;
    me.model.usuario = JSON.parse(localStorage.getItem('objSesionUsuarioLogeado') );
    //FIN INE(JJGJ) 20221018 - REQ22978
  }
  /*INICIO: INE(EGB) 20220705 - REQ22111*/
  hideDialog() {
    $('#AlertaPersonal').hide();
  }

  hideAlertaHorario() {
    $('#divMensaje').hide();
  }

  abrirLink(){
    window.open("https://evaluacionenlinea.mafperu.com.pe/prestamopersonal/index.html#/", "_blank", "noopener,noreferrer");
    $('#AlertaPersonal').hide();
  }
  /*FIN: INE(EGB) 20220705 - REQ22111*/
  //INI INE(JJGJ) 20221018 - REQ22978


  OnLoadConfiguraciones() {
    //try { /*MOD EXP(CMOGOLLON) 20241212 MEJORAS_SEGURIDAD*/
    this.configuracionesService
      .ListarConfiguraciones()
      .then((response) => {
        if(response.success){
        const { statusCode, configuraciones } = response.data;
        if (statusCode == 200) {
          this.configuraciones = configuraciones;
            this.changeConfiguraciones();
          }
          new AuditoriaNavegacionClass(this.auditoriaService)
            .guardarAuditoriaNavegacion(this.model.usuario.idusuario,
              this.modulo,
              this.opcion,
              '',
              'Listar configuraciones');
        }
      })
      .catch((err) => {
      //  console.log("Error interno");
      });
    //} catch (error) { /*MOD EXP(CMOGOLLON) 20241212 MEJORAS_SEGURIDAD*/
//console.log("Error interno");
    // } /*MOD EXP(CMOGOLLON) 20241212 MEJORAS_SEGURIDAD*/
  }


  showIn( configuraciones: Array<ConfiguracionModel>, index:number){
    const [{estadoElemento}] = this.configuraciones.filter((item) => (item.indentConfig == index));
    return estadoElemento == "1" ? true : false;
  }
  showInChecked( configuraciones: Array<ConfiguracionModel>, index:number,type:string){
    const [{estadoElemento}] = this.configuraciones.filter((item) => (item.indentConfig == index && item.tipoElemento == type));
    return estadoElemento == "1" ? true : false;
  }
  getImage( configuraciones: Array<ConfiguracionModel>, index:number,type:string){
    const [{contenidoElemento}] = this.configuraciones.filter((item) => (item.indentConfig == index && item.tipoElemento == type));
    return contenidoElemento ;
  }
  saveLocalStorage( configuraciones: Array<ConfiguracionModel>){
    const objConfig = this.configuraciones.filter((item) => (item.indentConfig == 2|| item.indentConfig == 3 || item.indentConfig == 4 || item.indentConfig == 12));//INE(PVR) REQ25710 20240306
    localStorage.setItem('objConfig', JSON.stringify(objConfig) );
  }
  changeConfiguraciones(){
    if (this.model.usuario.perfil == "Administrador") {
      localStorage.setItem('objConfig', JSON.stringify(this.configuraciones));
    } else {
      this.showPrestamo = this.showIn(this.configuraciones, 5)
      this.header.showChat = this.showIn(this.configuraciones, 11)
      this.menu.showMenuSeguro = this.showInChecked(this.configuraciones, 9, 'checkbox')
      this.menu.showMenuTramites = this.showInChecked(this.configuraciones, 10, 'checkbox');
      this.saveLocalStorage(this.configuraciones);
    }
    let [{ contenidoElemento }] = this.configuraciones.filter((item) => item.indentConfig == 2);
    this.footer.footerText = contenidoElemento
  }
  //FIN INE(JJGJ) 20221018 - REQ22978
}
